import axios from '@axios'

import qs from 'qs'

const prefixPath = '/api/ucenter/member'
export default {

  saveOrUpdate(data) {
    return axios.post(`${prefixPath}/saveOrUpdate`, data)
  },

  getPages(data) {
    return axios.post(`${prefixPath}/getPages`, data)
  },

  delete(id) {
    return axios.post(`${prefixPath}/removeMemberLevel`, qs.stringify({
      id,
    }))
  },
  getMemberLevel(id) {
    return axios.get(`${prefixPath}/getMemberLevel`, {
      params: {
        id,
      },
    })
  },
  listAll() {
    return axios.get(`${prefixPath}/listAll`)
  },

}
